// eslint-disable-next-line no-unused-vars
import {INNER_ROOT, USER_ROOT, COMMON_ROOT, transmission, WEB_METHODS} from '../../network/index'


const RANK_ROOT = '/rank'

const state = {}

const mutations = {}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {

	/**
	 * 무명부형 회원가입 > 직무 조회 
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getJobList ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT+RANK_ROOT}/jobList`, payload)
	},

	/**
	 * 무명부형 회원가입 > 직급 조회
	 * @param commit
	 * @param payload
	 * @returns {Promise<unknown>}
	 */
	// eslint-disable-next-line no-unused-vars
	async getPstList ({commit}, payload) {
		return transmission(false, WEB_METHODS.POST, `${INNER_ROOT+RANK_ROOT}/pstList`, payload)
	},
	
	
}

export default { state, mutations, actions }